import { onMount, Show } from 'solid-js'
import { clearSearchScope, isSearching, searchQuery, searchScope, setSearchQuery } from '../store/search.ts'
import { cn } from '../utils/cn.ts'
import { inputFrameClass } from './ui/TextField.tsx'

/* the one input in the app, so `/` and `.` need a way to reach it from anywhere */
let searchInput: HTMLInputElement | undefined

export function focusSearch(select = true) {
  searchInput?.focus()
  if (select) searchInput?.select()
}

export function SearchBar(props: { large?: boolean }) {
  let input!: HTMLInputElement

  // the landing bar and the app-bar bar are two different inputs, and typing the
  // first character swaps one for the other. without this the caret would land
  // nowhere and you'd have to click the box again to keep typing
  onMount(() => {
    searchInput = input
    input.focus()
    const end = input.value.length
    input.setSelectionRange(end, end)
  })

  return (
    <div class={cn(inputFrameClass, 'gap-2 px-2', props.large && 'px-3 py-1.5')}>
      <div class={cn('i-lucide-search shrink-0 text-muted-foreground', props.large ? 'size-4' : 'size-3.5')} />

      {/* the scope chip, code-search style: inside a repo the box searches that repo,
          and the chip is both the reminder and the way out of it */}
      <Show when={searchScope()}>
        {scope => (
          <span class="flex shrink-0 items-center gap-1 rounded bg-muted py-0.5 pl-1.5 pr-1 text-xs text-muted-foreground font-mono">
            {scope()}
            <button
              type="button"
              title="search every index"
              class="i-lucide-x size-3 cursor-pointer hover:text-foreground"
              onClick={() => {
                clearSearchScope()
                input.focus()
              }}
            />
          </span>
        )}
      </Show>
      <input
        ref={input}
        value={searchQuery()}
        onInput={e => setSearchQuery(e.currentTarget.value)}
        placeholder="foo repo:web lang:go /^func Test.*Errors$/ -ext:json"
        class={cn(
          'w-full bg-transparent py-1.5 font-mono outline-none placeholder:text-muted-foreground',
          props.large ? 'text-sm' : 'text-xs',
        )}
        spellcheck={false}
        autocomplete="off"
        onKeyDown={(e) => {
          // escape hands the keyboard back to the app, which is what makes single
          // letter shortcuts usable at all
          if (e.key === 'Escape') input.blur()
        }}
      />
      <Show when={isSearching()}>
        <div class="i-lucide-loader-circle size-3.5 shrink-0 animate-spin text-muted-foreground" />
      </Show>
      <Show when={searchQuery() && !isSearching()}>
        <div
          class="i-lucide-x size-3.5 shrink-0 cursor-pointer text-muted-foreground hover:text-foreground"
          onClick={() => {
            setSearchQuery('')
            input.focus()
          }}
        />
      </Show>
    </div>
  )
}
